import {
  GET_LIST_MAU_IN,
  GET_LIST_MAU_IN_SUCCESS,
  GET_LIST_MAU_IN_FAILURE,
  GET_NOI_DUNG_IN,
  GET_NOI_DUNG_IN_SUCCESS,
  GET_NOI_DUNG_IN_FAILURE,
} from "actions/InChoVay/actionTypes";

const initialState = {
  inChoVayLoading: false,
  ListMauIn: [],
  NoiDungIn: "",
};

const getListMauIn = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getListMauInSuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    ListMauIn: action.payload,
  };
};

const getListMauInFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  ListMauIn: [],
});

const getNoiDungIn = (state, action) => ({
  ...state,
  inChoVayLoading: true,
});

const getNoiDungInSuccess = (state, action) => {
  return {
    ...state,
    inChoVayLoading: false,
    NoiDungIn: action.payload,
  };
};

const getNoiDungInFailed = (state, action) => ({
  ...state,
  inChoVayLoading: false,
  NoiDungIn: "",
});

const inChoVayReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_MAU_IN:
      return getListMauIn(state, action);
    case GET_LIST_MAU_IN_SUCCESS:
      return getListMauInSuccess(state, action);
    case GET_LIST_MAU_IN_FAILURE:
      return getListMauInFailed(state, action);
    case GET_NOI_DUNG_IN:
      return getNoiDungIn(state, action);
    case GET_NOI_DUNG_IN_SUCCESS:
      return getNoiDungInSuccess(state, action);
    case GET_NOI_DUNG_IN_FAILURE:
      return getNoiDungInFailed(state, action);
    default:
      return state;
  }
};

export default inChoVayReducer;
